"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isEcommEvent = function (event) {
    return [
        'addTransaction',
        'addItem',
        'addImpression',
        'addProduct',
        'addPromo',
        'addAction',
        'ecommSend',
        'ecommClear',
    ].indexOf(event.hitType) > -1;
};
exports.default = isEcommEvent;
